import styles from './loading.module.css';

export function Loading() {
  return (
    <div className={styles.loaderWrapper}>
      <div className={styles.ldsEllipsis}>
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}
